import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import { Link } from "react-router-dom";

export default function SobreNosotrosPage() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />

      {/* Hero */}
      <section className="relative h-72 md:h-96 flex items-center justify-center overflow-hidden">
        <img
          src="https://public.readdy.ai/ai/img_res/6d454485553c4ae4e7ab29d3212f7df8.jpg"
          alt="Sobre GERPAT"
          className="absolute inset-0 w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-black/60"></div>
        <div className="relative z-10 text-center px-4">
          <span className="text-[#FF6B35] text-xs font-bold uppercase tracking-widest">Quiénes somos</span>
          <h1 className="text-4xl md:text-5xl font-extrabold text-white mt-2" style={{ fontFamily: "'Barlow Condensed', sans-serif" }}>
            SOBRE NOSOTROS
          </h1>
        </div>
      </section>

      {/* Main content */}
      <section className="py-20 bg-[#f8f7f5]">
        <div className="max-w-7xl mx-auto px-4 md:px-6">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
            <div>
              <span className="text-[#FF6B35] text-xs font-bold uppercase tracking-widest">Nuestra historia</span>
              <h2 className="text-3xl md:text-4xl font-extrabold text-[#1a1a1a] mt-3 mb-6" style={{ fontFamily: "'Barlow Condensed', sans-serif" }}>
                GERPAT LOGÍSTICA<br />I SERVEIS S.L.
              </h2>
              <p className="text-gray-600 text-sm leading-relaxed mb-4">
                GERPAT Logística i Serveis S.L. es una empresa con más de 15 años de experiencia en el sector del transporte, la grúa y la asistencia en carretera. Nacimos con la vocación de ofrecer un servicio profesional, rápido y de confianza a particulares y empresas de las provincias de Lleida y Huesca.
              </p>
              <p className="text-gray-600 text-sm leading-relaxed mb-4">
                A lo largo de los años hemos ampliado nuestra flota y nuestros servicios, incorporando equipos de última generación para dar respuesta a cualquier necesidad de transporte, desde turismos hasta maquinaria pesada. También contamos con un servicio de compra-venta de vehículos comerciales e industriales.
              </p>
              <p className="text-gray-600 text-sm leading-relaxed mb-8">
                Trabajamos con todas las compañías aseguradoras y ofrecemos un servicio integral que incluye la gestión de todos los trámites necesarios para que nuestros clientes no tengan que preocuparse de nada.
              </p>

              {/* Company data */}
              <div className="bg-white rounded-xl p-6 space-y-3">
                <h3 className="font-bold text-[#1a1a1a] text-sm uppercase tracking-wide mb-4">Datos de la empresa</h3>
                {[
                  { icon: "ri-building-line", label: "Razón social", value: "Gerpat Logística i Serveis S.L." },
                  { icon: "ri-file-list-line", label: "CIF", value: "B16976326" },
                  { icon: "ri-map-pin-line", label: "Dirección", value: "Partida San Juan S/N, Castillonroy 22572, Huesca" },
                  { icon: "ri-phone-line", label: "Teléfono", value: "+34 638 25 09 36" },
                  { icon: "ri-mail-line", label: "Email", value: "facturaciongerpat@gmail.com" },
                ].map((item) => (
                  <div key={item.label} className="flex items-start gap-3">
                    <div className="w-8 h-8 flex items-center justify-center bg-[#FF6B35]/10 rounded-lg flex-shrink-0">
                      <i className={`${item.icon} text-[#FF6B35] text-sm`}></i>
                    </div>
                    <div>
                      <div className="text-xs text-gray-400">{item.label}</div>
                      <div className="text-sm font-medium text-[#1a1a1a]">{item.value}</div>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            <div className="space-y-6">
              <div className="grid grid-cols-2 gap-6">
                <div className="w-full h-44 rounded-xl overflow-hidden">
                  <img
                    src="https://readdy.ai/api/search-image?query=professional%20tow%20truck%20driver%20in%20uniform%20smiling%2C%20Spain%2C%20logistics%20company%20employee%2C%20portrait%20photography&width=400&height=300&seq=about3&orientation=landscape"
                    alt="Equipo GERPAT"
                    className="w-full h-full object-cover object-top"
                  />
                </div>
                <div className="w-full h-44 rounded-xl overflow-hidden">
                  <img
                    src="https://readdy.ai/api/search-image?query=modern%20tow%20truck%20close%20up%20detail%2C%20orange%20and%20black%20colors%2C%20professional%20vehicle%2C%20Spain%2C%20industrial%20photography&width=400&height=300&seq=about4&orientation=landscape"
                    alt="Flota GERPAT"
                    className="w-full h-full object-cover object-top"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Values */}
      <section className="py-20 bg-[#1a1a1a]">
        <div className="max-w-7xl mx-auto px-4 md:px-6">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-extrabold text-white" style={{ fontFamily: "'Barlow Condensed', sans-serif" }}>NUESTROS VALORES</h2>
            <div className="w-16 h-1 bg-[#FF6B35] mx-auto mt-4 rounded-full"></div>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
            {[
              { icon: "ri-time-line", title: "Rapidez", desc: "Respuesta inmediata ante cualquier emergencia en las provincias de Lleida y Huesca." },
              { icon: "ri-shield-check-line", title: "Seguridad", desc: "Todos nuestros vehículos y operarios están debidamente asegurados y certificados." },
              { icon: "ri-heart-line", title: "Compromiso", desc: "Nos comprometemos con cada cliente como si fuera el único. Trato cercano y profesional." },
              { icon: "ri-star-line", title: "Calidad", desc: "Más de 15 años avalan nuestra trayectoria y la satisfacción de miles de clientes." },
            ].map((v) => (
              <div key={v.title} className="bg-[#252525] rounded-xl p-6 text-center">
                <div className="w-12 h-12 flex items-center justify-center bg-[#FF6B35]/20 rounded-full mx-auto mb-4">
                  <i className={`${v.icon} text-[#FF6B35] text-2xl`}></i>
                </div>
                <h3 className="text-white font-bold text-base mb-2">{v.title}</h3>
                <p className="text-gray-400 text-sm leading-relaxed">{v.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Map */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 md:px-6">
          <div className="text-center mb-10">
            <h2 className="text-2xl font-extrabold text-[#1a1a1a]" style={{ fontFamily: "'Barlow Condensed', sans-serif" }}>DÓNDE ESTAMOS</h2>
          </div>
          <div className="w-full h-80 rounded-xl overflow-hidden">
            <iframe
              title="Ubicación GERPAT Logística"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2975.0!2d0.6!3d41.9!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2sCastillonroy%2C+Huesca!5e0!3m2!1ses!2ses!4v1"
              width="100%"
              height="100%"
              style={{ border: 0 }}
              allowFullScreen
              loading="lazy"
            ></iframe>
          </div>
          <div className="text-center mt-6">
            <Link to="/contacto" className="inline-flex items-center gap-2 bg-[#FF6B35] hover:bg-[#e55a25] text-white font-bold px-8 py-3.5 rounded-full transition-colors whitespace-nowrap cursor-pointer">
              <i className="ri-mail-send-line"></i> Contactar con nosotros
            </Link>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
